export const FETCH_GEOCODE_LOCATION_ADD = 'FETCH_GEOCODE_LOCATION_ADD';
export const FETCH_GEOCODE_LOCATION_REQUEST = 'FETCH_GEOCODE_LOCATION_REQUEST';
export const FETCH_GEOCODE_LOCATION_FAILURE = 'FETCH_GEOCODE_LOCATION_FAILURE';
export const fetchGeoCodeLocationAdd = (payload) => ({
    type: FETCH_GEOCODE_LOCATION_ADD,
    payload,
});
export const fetchGeoCodeLocationRequest = () => ({
    type: FETCH_GEOCODE_LOCATION_REQUEST,
});
export const fetchGeoCodeLocationFailure = (payload) => ({
    type: FETCH_GEOCODE_LOCATION_FAILURE,
    payload,
});
